import React from 'react';
import { Button } from './ui/Button';
export function AboutSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-8" data-id="element-3">
          About Peak Machine Sales (Peak EDM Inc.)
        </h2>

        <div className="space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-4">
          <p data-id="element-5">
            At Peak Machine Sales, we take immense pride in representing some of
            the most impressive CNC machine tool lines in the industry. But,
            we're not just about selling machines. We're about understanding the
            unique needs and challenges of each of our customers. We tailor our
            offerings to fit like a glove, ensuring you get the most out of the
            solutions we have to offer.
          </p>

          <p data-id="element-6">
            Established in 1995, Peak Machine Sales stands as Michigan's
            foremost provider of CNC machine tool sales and service. Our
            expertise spans across High-Speed 3 & 5 Axis Milling, Conventional
            Milling & Turning, Wire and Sinker EDM, Laser Texturing/Ablation,
            Laser Cutting, Additive Manufacturing (3D Printing), Tooling, and
            Automation. Renowned for our commitment to quality customer support,
            we've assembled a team of highly skilled professionals dedicated to
            serving the Die Mold and precision part production industries. With
            strategically located offices in Wixom and Kalamazoo, Peak ensures
            comprehensive support for our product lines across the entire State
            of Michigan. Our deliberate selection of cutting-edge brands
            reflects our commitment to pioneering machining technology and
            manufacturing trends. Backed by factory-trained Peak Service
            Engineers, we ensure seamless service, directly supported by the
            OEMs we represent. This privileged access to internal databases
            empowers us to deliver factory-level service promptly and
            efficiently.
          </p>

          <p data-id="element-7">
            If you're curious to see how our CNC machine tools can work wonders
            for your business, please don't hesitate to drop us a line, shoot us
            a message, or give us a ring. We're always up for a chat, and we'd
            love to hear your goals and explore how our team can help you reach
            them. Thanks for considering Peak Machine Sales as your trusted
            source for precision CNC machines in Michigan. We look forward to
            building a fantastic partnership.
          </p>
        </div>

        <div className="mt-8" data-id="element-8">
          <Button variant="primary" href="8.html" data-id="element-9">
            Learn More About Peak
          </Button>
        </div>
      </div>
    </section>;
}